export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const quickLinks = [
    { name: 'Features', id: 'features' },
    { name: 'How It Works', id: 'how-it-works' },
    { name: 'Security', id: 'security' },
    { name: 'Privacy Policy', id: 'contact' },
    { name: 'Terms of Service', id: 'contact' }
  ];

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white rounded-t-[3rem]">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-3 gap-12 mb-12">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img
                src="https://public.readdy.ai/ai/img_res/bbdb48cc-b6a9-47b4-b3dc-55d7d18d113d.png"
                alt="JURINE SARL Logo"
                className="h-10 w-10 object-contain"
              />
              <h3 className="text-2xl font-bold">JURINE SARL</h3>
            </div>
            <p className="text-gray-400 leading-relaxed">
              Protecting your digital privacy with cutting-edge VPN technology. Browse securely, access content freely, and stay anonymous online.
            </p>
          </div>
          
          <div>
            <h4 className="text-lg font-bold mb-4">Quick Links</h4>
            <ul className="space-y-3">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <button
                    onClick={() => scrollToSection(link.id)}
                    className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer"
                  >
                    {link.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>
          
          <div>
            <h4 className="text-lg font-bold mb-4">Contact Information</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <i className="ri-phone-line text-teal-400 text-xl flex-shrink-0"></i>
                <span className="text-gray-400">+1 2135830795</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-mail-line text-teal-400 text-xl flex-shrink-0"></i>
                <span className="text-gray-400">information@jurinesarl.com</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-line text-teal-400 text-xl flex-shrink-0"></i>
                <span className="text-gray-400">
                  95 RUE ROCHE DU GEAI<br />
                  42000 SAINT-ETIENNE<br />
                  France
                </span>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              © 2025 JURINE SARL. All rights reserved.
            </p>
            <a
              href="https://readdy.ai/?origin=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-teal-400 text-sm transition-colors"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
